import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAuditLogUpsellCtaClicked.meta';

export type AuditLogUpsellCtaType = 'badge' | 'link';

export type UseTrackAuditLogUpsellCtaClickedParams = {
  cta_type: AuditLogUpsellCtaType;
  workspace_id: string;
};

export const useTrackAuditLogUpsellCtaClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackAuditLogUpsellCtaClicked = useCallback(
    (params: UseTrackAuditLogUpsellCtaClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAuditLogUpsellCtaClicked };
};
